import { TextLink, useListContextRequired, useShowContextRequired } from 'ui-builder';
import { VerifyDataEntry } from './types';
import { ProjectDetailsFieldType, RelativeDateOffset, useDateHelper } from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';
import React from 'react';
import { UpdateParseValueForm } from './UpdateParseValueButton';

export function ParsedValueField(props: { projectId: number }) {
  const showContext = useShowContextRequired<VerifyDataEntry>();

  const listContext = useListContextRequired<VerifyDataEntry>();

  const dateHelper = useDateHelper();

  const field = showContext.data!.detailsField;

  const getRelativeDateOffsetValue = (value: RelativeDateOffset) => {
    const parentField = listContext.data.find((item) => item.detailsField?.id === value.dependsOnFieldId);

    const dayName = value.useBusinessDaysCalculation ? 'business' : 'calendar';

    if (value.days !== undefined) {
      return `${value.days} ${dayName} ${value.days === 1 ? 'day' : 'days'} ${value.when} "${parentField?.name}"`;
    } else {
      return 'N/A';
    }

  };

  let textValue;

  if (showContext.data!.parsedValue) {
    const value = showContext.data!.parsedValue.value;

    if (value) {
      if (typeof value === 'object' && !(value instanceof Date)) {
        textValue = getRelativeDateOffsetValue(value as RelativeDateOffset);
      } else {
        if (field?.fieldType === ProjectDetailsFieldType.DATE && value instanceof Date) {
          textValue = dateHelper.toString(new Date(value));
        } else {
          if (field?.fieldType === ProjectDetailsFieldType.PRICE) {
            textValue = `$${value}`;
          } else {
            textValue =  value.toString();
          }
        }
      }
    } else {
      textValue =  'N/A';
    }
  } else {
    textValue = '-';
  }

  const popupFormManager = usePopupFormManager();

  return (
    <TextLink
      onClick={() => popupFormManager.openForm(<UpdateParseValueForm data={showContext.data!} projectId={props.projectId} />)}
    >
      {textValue}
    </TextLink>
  )
}
